import { cn } from '@/utils/lib/cn';
import { Button, type ButtonProps } from './Button';

export const SubmitButton = ({ children, ...props }: ButtonProps) => {
  return (
    <Button
      type='submit'
      {...props}
    >
      {children}
    </Button>
  );
};

export function ButtonLoader({ className = '' }: { className?: string }) {
  return (
    <div
      className={cn(
        'mx-4 mr-1.5 size-4 animate-spin rounded-full border-2 border-solid border-white border-l-stone-950',
        className,
      )}
    />
  );
}
